<template>
  <div class="key-item">
    <div class="key-item__square" :class="'key-item__square--' + color"></div>
    <div class="key-item__label">{{label}}</div>
  </div>
</template>

<script>
export default {
  name: 'CourseKey',
  props: ['color', 'label'],
  data () {
    return {

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import '~styles/vars';
  .key-item {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    width: 33%;
    max-width: 214px;
    min-width: 174px;
    margin-bottom: 20px;
    &__square {
      width: 24px;
      height: 24px;
      border-radius: 2px;
      display: block;
      margin-right: 14px;
      &--marshall-core {
        background-color: $cMarshallCore;
      }
      &--marshall-elective {
        background-color: $cMarshallElective;
      }
      &--usc-requirement {
        background-color: $cUSCRequirement;
      }
      &--usc-elective {
        background-color: $cUSCElective;
      }
      &--accounting {
        background-color: $cAccounting;
      }
      &--cinematic-arts {
        background-color: $cCinematicArts;
      }
      &--viterbi-core {
        background-color: $cViterbiCore;
      }
      &--ai {
        background-color: $cAI;
      }
    }
    &__label {
      font-size: 15px;
      font-family: "National";
      color: $cBody;
      font-style: italic;
      line-height: 1.6;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CourseChart/CourseChartKey.vue